module.exports = __webpack_public_path__ + "static/media/landingPageVideo2.cccf05d3.webp";